module.exports = __webpack_public_path__ + "static/cristina-jones-9347a8955de2effedc04ec2db0b5d3ff.jpg";